// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__t7_Y0","legacyBtn":"MutateMid_legacyBtn__2CxAw"};